import baseApi from "./baseApi";
import axios from "axios";

const whois = async (r) => await axios.post(`Domain/Whois`, r, { headers: { 'Authorization': 'Bearer ' + baseApi.getToken() } });


export default {
    whois
};